import { employersDirectoryMainComponent } from './employers-directory-main.component'

export const employersDirectoryMain = angular
.module("components.employers-directory.employers-directory-main.employersDirectoryMain",[])
.component("employersDirectoryMain", employersDirectoryMainComponent).name


// WEBPACK FOOTER //
// ./src/app/components/employers-directory/employers-directory-main/employers-directory-main.module.js